module.exports = __webpack_public_path__ + "static/media/clear_input.19eec39c.svg";